//region :: Imports ::
import React, {Component, MouseEventHandler, ReactElement} from 'react';
import {classNames} from 'primereact/utils';

//endregion

/** */
type Props = {
    label: string;
    icon: string;
    onClick: MouseEventHandler<HTMLButtonElement>;
}

/** */
class MTopbarButton extends Component<Props> {

    /** */
    public render(): ReactElement {

        return (
            <button className="p-link mshell-topbar-button" onClick={this.props.onClick}>
                <i className={classNames('pi', this.props.icon)}/>
                <span>{this.props.label}</span>
            </button>
        );

    }

}

export default MTopbarButton;
